import { render, staticRenderFns } from "./BnGapDijCard.vue?vue&type=template&id=59f1e71c&scoped=true&"
import script from "./BnGapDijCard.vue?vue&type=script&lang=js&"
export * from "./BnGapDijCard.vue?vue&type=script&lang=js&"
import style0 from "./BnGapDijCard.vue?vue&type=style&index=0&id=59f1e71c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f1e71c",
  null
  
)

export default component.exports